module.exports = __webpack_public_path__ + "img/banner.b1af8b83.png";